// extracted by css-extract-rspack-plugin
export default {"CodespacesSkeletonWrapper":"CodespacesTab-module__CodespacesSkeletonWrapper__UMITW","SkeletonLoaderWrapper":"CodespacesTab-module__SkeletonLoaderWrapper__fpFwY"};